import React, { useEffect, useState } from "react";
import root from "react-shadow";

import { getHtmlFromSvg } from "../util";

const FloorplanSVG = (props: {
  svg: string;
  vpbPkid: number;
  layerIds: string[];
  visibleLayers: string[];
  flipCss: boolean;
}) => {
  const [svg, setSvg] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchSvg = async () => {
      setSvg("");
      const newValue = await getHtmlFromSvg(props.svg);

      setSvg(newValue);
    };

    fetchSvg();
  }, [
    props.svg,
  ]);

  const getLayerStyles = () => {
    return props.layerIds.map((layerId) => {
      if (props.visibleLayers.indexOf(layerId) > -1) {
        return `[id$="${layerId}"] { display: block; } `;
      }
      return `[id$="${layerId}"] { display: none; } `;
    });
  };

  return (
    <root.div>
      <div
        className={`svg-container ${ props.flipCss ? "flip-css" : ""}`}
        dangerouslySetInnerHTML={{ __html: svg }}
      />
      <style>
        {`.svg-container svg {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
        }
        svg > g { display: none; }
        svg > g:first-of-type { display: block; }
        svg > g[id$="Base"] { display: block; }
        .svg-container.flip-css svg { transform: scaleX(-1); }
      `}
      </style>
      <style>{getLayerStyles()}</style>
    </root.div>
  );
};

export default FloorplanSVG;
